import React from 'react'
import design from './BlueButton.module.css'
function BlueButton(props) {
  return (
    <button
      onClick={props.onClick}
      type={props.type}
      onChange={props.onChange}
      className={design.button}>{props.children}</button>
  )
}

export default BlueButton